//
// ops-config.js
//
// Copyright (c) 2014 by Curalate, Inc.
//

/* global angular: false, ace: false */

((() => {
    angular.module('curalate', ['ui.ace', 'ngRoute', 'ngTable', 'highcharts-ng', 'angularFileUpload',
                                'angularUtils.directives.dirPagination', 'products.constants', 'ui.bootstrap',
                                'xeditable', 'isteven-multi-select', 'angular-json-tree']);

    angular.module('curalate').config(paginationTemplateProvider => {
        paginationTemplateProvider.setPath('/templates/partials/pagination.tpl.html');
    });

    // Configure Ace rich text editor to pull JS files from correct directory
    ace.config.set('basePath', '/jslib/ace-builds/src-min');
    ace.config.set('modePath', '/jslib/ace-builds/src-min');
    ace.config.set('themePath', '/jslib/ace-builds/src-min');
    ace.config.set('workerPath', '/jslib/ace-builds/src-min');
}))();
